import { render, staticRenderFns } from "./edit-editor.vue?vue&type=template&id=1c3fc599&"
import script from "./edit-editor.vue?vue&type=script&lang=js&"
export * from "./edit-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports